"use client";

import { createContext, useContext } from "react";
import { defaultLocale, localizePath, type Locale } from "../lib/i18n/config";

const LocaleContext = createContext<Locale>(defaultLocale);

export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

/** Returns a function that localizes internal hrefs for the current locale. */
export function useLocalizedHref() {
  const locale = useLocale();
  return (href: string) => localizePath(locale, href);
}
